import { Vue } from 'vue-property-decorator';

export default class SortHlasMixin extends Vue {
    sortHlas(sorted: any) {
        sorted.forEach(function (val: any) {
            if (val.hlaTypeName == "DQB1*") {
                val.sortValue = val.hlaTypeValue + 1;
            } else if (val.hlaTypeName == "DRB1*") {
                val.sortValue = val.hlaTypeValue - 1;
            } else {
                val.sortValue = val.hlaTypeValue;
            }
        });
        sorted.sort(function (a: any, b: any) {
            return a.sortValue - b.sortValue;
        });
    }
}